import { isValidCharacterId } from '@shared/index'
import { createFileRoute } from '@tanstack/react-router'

import PagePlaygroundCharacterNanobanana from '../pages/PagePlaygroundCharacterNanobanana'

type CharacterNanobananaSearch = {
  runId?: string
  character?: string
}

export const Route = createFileRoute('/playground/character-nanobanana')({
  component: PagePlaygroundCharacterNanobanana,
  validateSearch: (search: Record<string, unknown>): CharacterNanobananaSearch => ({
    runId: typeof search.runId === 'string' && search.runId.length > 0 ? search.runId : undefined,
    character: isValidCharacterId(search.character) ? search.character : undefined
  })
})
